@if (initializing) {
  <bit-icon
    name="bwi-spinner"
    class="bwi-spin bwi-2x tw-text-muted"
    [ariaLabel]="'loading' | i18n"
  ></bit-icon>
} @else {
  @if (showWarning && forceSetPasswordReason !== ForceSetPasswordReason.AdminForcePasswordReset) {
    <div class="bv-security-warning-banner" role="alert">
      <bit-icon name="bwi-exclamation-triangle" class="bv-security-warning-banner__icon" />
      <div class="bv-security-warning-banner__content">
        <p class="bv-security-warning-banner__title">{{ "warning" | i18n }}</p>
        <p class="bv-security-warning-banner__message">{{ "loggedOutWarning" | i18n }}</p>
      </div>
      <button
        type="button"
        bitIconButton="bwi-close"
        buttonType="subtleGhost"
        size="small"
        class="bv-security-warning-banner__close"
        [label]="'close' | i18n"
        (click)="showWarning = false"
      ></button>
    </div>
  }

  <app-web-input-password
    [flow]="inputPasswordFlow"
    [email]="email"
    [userId]="userId"
    [loading]="submitting"
    [masterPasswordPolicyOptions]="masterPasswordPolicyOptions"
    [inlineButtons]="true"
    [primaryButtonText]="{ key: 'changeMasterPassword' }"
    (onPasswordFormSubmit)="handlePasswordFormSubmit($event)"
    [secondaryButtonText]="secondaryButtonText()"
    (onSecondaryButtonClick)="logOut()"
  ></app-web-input-password>
}
